/**
 * Here you implement your functions you want to use everywhere in your application.
 * See this functions as an example.
 */
const DEBUG = true;

/////////////////////
/// devices helper //
/////////////////////

// < IE9
export const isOldBrowser = !(('querySelector' in document) && ('localStorage' in window) && ('addEventListener' in window));
  // includes tables and smartphones
export const isMobile = !isUndefined(window.orientation) || window.innerWidth < 420;
  // smartphone detection (android,iphone,blackberry,windows phone)
export const isSmartphone = /android.*mobile|mobile.*android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // device depending click event
export const clickEvent = isMobile ? 'touchstart' : 'click';

export const isDesktop = window.innerWidth > 786;

const version = detectIE();
export const isOldIE = version && version < 12;



///////////////////////
/// helper functions //
///////////////////////

export function isUndefined(obj) {
  return typeof obj === 'undefined';
}

export function isNumeric(number) {
  if(isUndefined(number)){
    return false;
  }

  return !isNaN(number) && isFinite(number);
}

export function numberFormat(number) {

  if (!isNumeric(number)) {
    return false;
  }

  return number.toLocaleString('de-DE');
}

// add some classes to the html element
export function addHelperClasses() {
  let htmlElement = document.getElementsByTagName('html')[0],
    className = [];

  if (isOldBrowser) {
    className.push('is-oldbrowser');
  }

  if (isMobile) {
    className.push('is-mobile');
  }

  if (isSmartphone) {
    className.push('is-smartphone');
  }

  htmlElement.className = className.join(' ');
}

export function log(){
  if(!DEBUG) {
    return false;
  }

  let args = Array.prototype.slice.call(arguments);

  if(args.length === 1){
    args = args[0];
  }

  console.log(args);
}

// check horizontal edges
export function elementInHorizontalViewport(xPos, vpWidth) {
  return xPos + 200 < vpWidth;
}

// check vertical edges
export function getYPos(yPos, vpHeight) {
  if (yPos + 90 > vpHeight) {
    return yPos - 45;
  } else if (yPos < 120) {
    return yPos + 45;
  }
  return yPos;
}

function detectIE() {
  let ua = window.navigator.userAgent;
  let msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  let trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    let rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  let edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }
  // other browser


  return false;
}



// WEBPACK FOOTER //
// ./src/helper/utils.js